(() => {
  let dialog;
  let opener;
  const root = document.querySelector('main.ms-oem-main');
  if (!root) return;

  const createDialog = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'ms-oem-gallery';
    dialog.setAttribute('aria-label', 'Enlarged OEM reference image');
    dialog.innerHTML = '<button type="button" data-oem-gallery-close aria-label="Close enlarged image">×</button><img alt=""><p></p>';
    root.append(dialog);
    dialog.addEventListener('close', () => {
      if (opener?.isConnected) opener.focus();
      opener = null;
    });
    dialog.querySelector('[data-oem-gallery-close]').addEventListener('click', () => dialog.close());
    return dialog;
  };

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('main.ms-oem-main [data-gallery]');
    if (trigger) {
      const modal = dialog || createDialog();
      const caption = trigger.dataset.caption || trigger.querySelector('img')?.alt || '';
      opener = trigger;
      modal.querySelector('img').src = trigger.dataset.gallery;
      modal.querySelector('img').alt = caption;
      modal.querySelector('p').textContent = caption;
      modal.showModal();
    }
  });
})();
